<template>
    <div>
        <div class="warp">
            <el-upload
                :action="baseUrl+action"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :accept="accept?accept:'application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword'"
                :multiple="true"
                :http-request="myupload">
                <div class="btn">上传附件</div>
            </el-upload>
            
            <div class="texts">{{tip?tip:`附件总计不超过${size}M`}}</div>
        </div>
        <template v-if="progress && progress.length !== 0">
        <el-progress v-for="(item,idx) in progress" :key="idx" v-if="item.videoFlag == true" :percentage="item.videoUploadPercent" style="margin-top:30px;width:50%" ></el-progress>
        </template>
        <div class="attachment" v-if="value && value.length !== 0">
            <ul>
                <li v-for="(item,index) in value" :key="index">
                    <img src="../assets/common/down1.png">
                    <span>{{item.fileName}}</span>
                    <img src="../assets/common/del.png" @click="del(index)">
                </li>
            </ul>
        </div>
    </div> 
</template>

<script>
import {API} from "@/axios/config";
import axios from 'axios'
export default {
    props:{
        action:String,
        accept:String, //图片image/png,image/jpg,image/jpeg,image/bmp; 文件application/pdf ; xlx和xlsx application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; .doc:application/msword
        size:Number,//以m为基数
        alone:Boolean,//是否是单文件上传 true是
        value:Array,//v-model的值
        tip:{
          type:String,default:''
        }
    },
    data(){
        return{
            baseUrl:API.UploadsService,//服务器
            fileList:[],//显示文件列表
            fileSizeList:[],//临时存储文件size数组
			      number:20,
            videoUploadPercent:0,
            videoFlag:false,
            progress:[]
        }
    },
	watch:{
	    value(newVal,oldVal){
	        this.fileList=newVal || [];
	    }
	},
    methods:{ 
      
        //上传前
        beforeUpload:function(file){
            if(this.alone){ //单文件上传
                let limitSize=file.size /1024 / 1024;
                if(limitSize>this.size){
                    this.$message({
                        message: '文件总大小不得超过'+this.size+'M',
                        type: 'error'
                    });
                    return false;
                }else{
                    return true;
                }
            }else{ //多文件上传
                let limitSize=0;//所有文件总大小
                let beforeSize=file.size;//上传前文件大小
                let fileSizeTotal=0;//已上传列表的文件数组总大小
                for(let item of this.fileSizeList){
                    fileSizeTotal+=item.size;
                }
                limitSize=(fileSizeTotal+beforeSize) / 1024 / 1024;
                if(limitSize>this.size){
                    this.$message({
                        message: '文件总大小不得超过'+this.size+'M',
                        type: 'error'
                    });
                    return false;
                }else{
                    this.fileSizeList.push(file);
                    return true;
                }
            }
        },
        //自定义上传
        myupload:function(content){
          const that = this
          const token = that.$store.state.user.token
            let formData = new FormData();
            let index = that.progress.length
            if(that.alone){
                that.progress.push({videoFlag:true,videoUploadPercent:content.file.percentage})
                formData.append("file",content.file);
            }else{
                that.progress.push({videoFlag:true,videoUploadPercent:content.file.percentage})
                formData.append("files",content.file);
            }
            return  axios({
          url: content.action,
          method: 'post',
          data: formData,
          headers: { 
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          },
          onUploadProgress: progressEvent => {
            // 进度条
            // that.progress.filter((item,idx)=>{
            //   if(item.)
            // })
            that.progress[index].videoUploadPercent = ((progressEvent.loaded / progressEvent.total) * 100).toFixed(0) | 0
          }
        }).then(res => {
          console.log(res)
          const r = res.data
          if(r.code===200  && that.progress[index].videoUploadPercent === 100){
                  that.progress[index].videoUploadPercent = 0;
                  that.progress[index].videoFlag = false
                  
                    if(that.alone){ //单
                        that.fileList.push(r.data);
						that.$emit('input',that.fileList);
						that.$message({
						    message: '上传成功',
						    type: 'success'
						});
                    }else{ //多
						if(that.fileList.length+r.data.length>that.number){
							that.$message({
								message: `文件上传数量不能超过${that.number}`,
								type: 'error'
							});
						}else{
							that.fileList=[...that.fileList,...r.data];
							that.$message({
							    message: '上传成功',
							    type: 'success'
							});
							that.$emit('input',that.fileList);
						}
                    }  
                    
                }else{   
                    that.videoUploadPercent = 0;
                    that.$alert(r.msg);
                }
          // if (res.data.status === 200 && that.progressPercent === 100) {
          //   setTimeout(function () {
          //     that.$message({
          //       message: '上传成功！',
          //       type: 'success',
          //       duration: '2000'
          //     })
          //     that.progressFlag = false
          //     that.progressPercent = 0
          //     that.$refs.uploadMul.clearFiles()
          //   }, 1000)
          //   let result = res.data.body.data
          //   console.log(result)
          // } else {
          //   setTimeout(function () {
          //     that.$message({
          //       message: res.data.msg,
          //       type: 'error',
          //       duration: '2000'
          //     })
          //     that.progressFlag = false
          //     that.progressPercent = 0
          //     that.$refs.uploadMul.clearFiles()
          //   }, 1000)
          // }
        }).catch(() => {
          that.progressFlag = false
          that.progressPercent = 0
          that.$refs.uploadMul.clearFiles()
          that.$message({
            message: '上传失败！',
            type: 'error',
            duration: '2000'
          })
        })

            that.$axiosz.post(content.action,formData).then((r)=>{
              that.videoUploadPercent = 100;
              that.videoFlag = false;
                if(r.code==200){
                  
                  
                  that.videoUploadPercent = 0;
                  clearInterval(interval)
                    if(that.alone){ //单
                        that.fileList=[r.data];
						that.$emit('input',that.fileList);
						that.$message({
						    message: '上传成功',
						    type: 'success'
						});
                    }else{ //多
						if(that.fileList.length+r.data.length>that.number){
							that.$message({
								message: `文件上传数量不能超过${that.number}`,
								type: 'error'
							});
						}else{
							that.fileList=[...that.fileList,...r.data];
							that.$message({
							    message: '上传成功',
							    type: 'success'
							});
							that.$emit('input',that.fileList);
						}
                    }  
                    
                }else{   
                    that.videoUploadPercent = 0;
                    that.$alert(r.msg);
                }
            })
        },
        //删除
        del:function(i){  
            this.fileList.splice(i,1);
            this.$emit('input',this.fileList);
        }
    },
    mounted(){  
    },
}
</script>

<style lang="scss" scoped> 
.warp{
    display: flex;
    align-items: center;
    .btn{
        width:82px;
        height:35px;
        background:#1069DD;
        border-radius:3px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:35px;
        text-align: center;
        color:rgba(255,255,255,1);
    }
    .texts{
        font-size:10px;
        font-weight:400;
        color:rgba(177,177,177,1);
        margin-left: 27px;
    }
}
</style>